var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRatting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20.3 18.9",
    style: {
      enableBackground: "new 0 0 20.3 18.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.1,8.1c0.6-0.6,0.3-1.5-0.6-1.5l-4.8-0.7c-0.3-0.1-0.6-0.3-0.6-0.6L11,0.7C10.6,0,9.7,0,9.3,0.6L7.1,5.2 C7,5.5,6.8,5.8,6.5,5.8L1.7,6.5c-0.7,0.1-1,1-0.6,1.6l3.5,3.6c0.2,0.2,0.4,0.6,0.3,0.8l-0.8,5c-0.2,0.8,0.6,1.4,1.3,1l4.3-2.4 c0.3-0.2,0.6-0.2,0.8,0l4.3,2.4c0.6,0.4,1.4-0.3,1.3-1l-0.8-5c0-0.3,0.1-0.6,0.3-0.8L19.1,8.1z M13.9,11c-0.1,0.1-0.2,0.4-0.2,0.6 l0.6,3.4c0.1,0.5-0.4,1-0.9,0.7l-3-1.7c-0.2-0.1-0.4-0.1-0.6,0l-3,1.7C6.4,16,5.8,15.6,6,15l0.6-3.4c0.1-0.2-0.1-0.4-0.2-0.6 L3.9,8.5c-0.3-0.4-0.1-1,0.4-1.1l3.3-0.5c0.2,0,0.4-0.2,0.4-0.4l1.5-3.2c0.3-0.4,1-0.4,1.2,0.1l1.5,3.2c0.1,0.2,0.3,0.3,0.4,0.4 L16,7.5c0.6,0,0.8,0.6,0.4,1L13.9,11z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatting);
export default __webpack_public_path__ + "static/media/ratting.d4f340f0b4f8f358e58c839cf9704f73.svg";
export { ForwardRef as ReactComponent };